import React, { KeyboardEvent } from 'react';
import { FormikErrors, FormikTouched, useField } from 'formik';
import { ActivateAccountFormInput } from '../../interfaces/interfaces';
import { Button, Col, Row } from 'react-bootstrap';
import TextField from '../text-field/text-field';
import { emailSchema } from '../../utils/formSchema';
import styles from './verify-email.module.scss';
import { FormErrorPanel } from '../form-error-panel/form-error-panel';

export type VerifyEmailInputProps = {
  handleSubmit: () => void;
  isLoading: boolean;
  error?: string;
  errors: FormikErrors<ActivateAccountFormInput>;
  touched: FormikTouched<ActivateAccountFormInput>;
};

export function VerifyEmail({
  handleSubmit,
  isLoading,
  error,
}: VerifyEmailInputProps) {
  const [, meta] = useField<string>('email');
  const { value } = meta;

  const isEmailValid = () => {
    return !isLoading && emailSchema.isValidSync({ email: value });
  };

  return (
    <>
      <div style={{ height: '38px' }}></div>
      <Row>
        <Col>
          <p className={styles['header']}>Sign up with your work email</p>
          <TextField
            label="Work Email"
            name="email"
            placeholder="name@company.com"
            onKeyUp={(event: KeyboardEvent) => {
              if (event.key === 'Enter' && isEmailValid()) {
                handleSubmit();
              }
            }}
          />
          <div className={styles['tip-box']}>
            <span>Tip: Use your work email</span> (if you have one) so it&apos;s
            easier for your team to join you at SPINS
          </div>
        </Col>
      </Row>
      {error && (
        <Row>
          <Col>
            <FormErrorPanel message={error} />
          </Col>
        </Row>
      )}
      <Row className={styles['button-row']}>
        <Col>
          <Button
            disabled={!isEmailValid()}
            color="primary"
            id="button-next"
            onClick={handleSubmit}
            style={{ width: '100%' }}
          >
            Next
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default VerifyEmail;
